import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  toast: {
    padding: '16px',
    width: '520px',
    border: 'none'
  },
  toastContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    gap: '8px'
  },
  toastIcon: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.displayXXSmall
  },
  textContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    width: '100%',
    gap: '4px'
  },
  body: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  closeButton: {
    height: '16px',
    width: '16px',
    borderRadius: '50%',
    '&:hover': {
      '& .MuiSvgIcon-root': {
        color: capitalDesignTokens.semanticColors.foreground.primary
      }
    }
  },
  closeIcon: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyDefault,
    color: capitalDesignTokens.foundations.colors.white
  }
});
